import { VehicleAssignment } from '@fc-core/services/vehicle-assignments.service';

export interface UserPermissions {
  readonly accounting_customer_can_switch_customer_view: boolean;
}

export interface EmployeeGroupPermission {
  id: number;
  name: string;
  description: string;
  isSelected: boolean;
  permissions?: Permission[];
}

export interface Permission {
  id: number;
  name: string;
  fullCodename: keyof UserPermissions;
  codename: string;
}

export interface PermissionState extends Permission {
  active: boolean;
}

export interface EmployeeGroup {
  id?: any;
  name?: string;
  employees?: string[];
  color?: string;
  description?: string;
  visibility?: { vehicles: { all: boolean; groups: number[] } };
}

export interface InvitePayload {
  firstName: string;
  lastName: string;
  email?: string;
  primaryPhoneNumber?: string;
  groups?: number[];
  timezone?: string;
  isOperator?: boolean;
  isAdmin?: boolean;
  streetAddress?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  platformAccess: PlatformAccess[];
  website?: string;
  description?: string;
}

export interface Invite {
  id?: string;
  groups?: number[];
  fullGroups?: EmployeeGroup[];
  employee: string;
}

export interface ShortUser {
  id: string;
  email: string;
}

export interface User {
  id?: string;
  lastLogin?: string;
  email?: string;
  pendingEmail?: string;
  isActive?: boolean;
  isStaff?: boolean;
  isSuperuser?: boolean;
  permissions?: Permission[];
  dateJoined?: string;
}

export interface Employee {
  id?: string;
  firstName?: string;
  lastName?: string;
  customer?: string;
  user?: ShortUser;
  fullName?: string;
  primaryPhoneNumber?: string;
  secondaryPhoneNumber?: string;
  timezone?: string;
  avatar?: any;
  groups?: number[];
  role?: number;
  isAdmin?: boolean;
  email?: string;
  fullGroups?: EmployeeGroup[];
  hasInvite?: boolean;
  inviteId?: string;
  operator?: { id: number };
  archived?: boolean;
  archivedOn?: string;
  streetAddress?: string;
  postalCode?: string;
  city?: string;
  state?: string;
  website?: string;
  description?: string;
  color?: string;
  permissions?: Permission[];
  setstatus?: StatusSet;
  platformAccess?: PlatformAccess[];
  vehicleAssignment?: VehicleAssignment | null;
}

export interface EmployeeFilter {
  name: string;
  key: string;
  selected: boolean;
}

export interface UserFilterTypes {
  active: boolean;
  invites: boolean;
  disabled?: boolean;
}

export interface StatusSet {
  id?: number;
  employee?: string;
  status?: string;
  icon?: string;
  duration?: {
    lower?: string;
    upper?: string | null;
    bounds?: string;
  };
  createdBy?: string;
}

export type PlatformAccess = 'console' | 'employee_app' | 'no_access';

// todo, temporary solution, remove later
export const employeeFields = [
  'id',
  'first_name',
  'last_name',
  'customer',
  'user',
  'full_name',
  'primary_phone_number',
  'secondary_phone_number',
  'timezone',
  'avatar',
  'groups',
  'role',
  'is_admin',
  'email',
  'full_groups',
  'has_invite',
  'operator',
  'archived',
  'archived_on',
  'street_address',
  'postal_code',
  'city',
  'state',
  'website',
  'description',
  'color',
  'permissions',
  'setstatus',
  'platform_access',
  'vehicle_assignment',
];
